import axios from "axios";
import qs from "qs";
import _ from "lodash";

const { CancelToken } = axios;
let source = CancelToken.source();

export const baseUrl = `${process.env.REACT_APP_HOST}`;
const ax = axios.create({
  baseURL: baseUrl,
  timeout: `${process.env.REACT_APP_TIMEOUT}`,
  cancelToken: source.token,
  headers: { Accept: "application/json" },

  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: "brackets" });
  },
});

export class Api {
  static _token = "";

  static request(config, successCb, failCb) {
    const promise = ax.request(config);
    if (_.isFunction(successCb)) {
      promise.then(successCb);
    }
    if (_.isFunction(failCb)) {
      promise.catch(failCb);
    }
    return promise;
  }

  static setLanguage(language) {
    const formattedLanguage = language || "de_DE";

    if (ax.defaults.params && ax.defaults.params._language === formattedLanguage) {
      // already set, nothing to do
      return 0;
    } else {
      ax.defaults.params = {
        ...ax.defaults.params,
        _language: formattedLanguage,
        _channel: "_default",
      };
      return 1;
    }
  }

  static setCustomParam(key, value) {
    if (ax.defaults.params && ax.defaults.params[key] === value) {
      // already set, nothing to do
      return 0;
    } else {
      ax.defaults.params = {
        ...ax.defaults.params,
        [key]: value,
      };
      return 1;
    }
  }

  static getGETParameters() {
    return {
      ...ax.defaults.params,
    };
  }

  static cancel() {
    source.cancel();
    source = CancelToken.source();
    ax.defaults.cancelToken = source.token;
  }

  static setToken(token) {
    this._token = token;
    ax.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  static getToken() {
    return this._token;
  }

  static init(config) {
    config.map((key) => {
      ax.defaults[key] = config[key];
      return null;
    });
  }
}

export const isCancelError = (error) => error instanceof axios.Cancel;

export default Api;
